import { countrySelectData } from "../../../data/countriesData";
import {
  TConfigItemType,
  TVerificationAppFieldConfigItem,
} from "../../app/models";
import { cleanupTaxIds } from "./parseTaxEntries";

export function normalizeCountrySelectValue(value: unknown): unknown {
  if (value == null || value === "") return value;
  if (typeof value !== "string") return value;

  const normalized = value.trim();
  if (!normalized) return "";

  const normalizedLower = normalized.toLowerCase();
  const matchingCountry = countrySelectData.find(
    (country) =>
      String(country.value).toLowerCase() === normalizedLower ||
      String(country.label).toLowerCase() === normalizedLower
  );

  return matchingCountry?.value ?? value;
}

export function cleanupCountrySelects(
  values: Record<string, unknown>,
  configFields?: TVerificationAppFieldConfigItem[]
): Record<string, unknown> {
  if (!configFields || configFields.length === 0) {
    return values;
  }

  let result: Record<string, unknown> | undefined;
  for (const field of configFields) {
    if (field.type !== TConfigItemType.COUNTRY_SELECT) continue;
    if (typeof field.name !== "string") continue;
    if (values[field.name] === undefined) continue;

    const normalizedValue = normalizeCountrySelectValue(values[field.name]);
    if (normalizedValue !== values[field.name]) {
      result = result ?? { ...values };
      result[field.name] = normalizedValue;
    }
  }

  return result ?? values;
}

export function cleanupConfigFieldValues(
  values: Record<string, unknown>,
  configFields?: TVerificationAppFieldConfigItem[]
): Record<string, unknown> {
  values = cleanupCountrySelects(values, configFields);
  values = cleanupTaxIds(values, configFields);
  return values;
}
